<template>
  <div
    :class="{ pointer_container: true, on_nav: bigger }"
    id="cursor_pointer"
    ref="pointer"
    v-if="!isMobile"
  ></div>
</template>

<script>
import { isMobile } from "@/utils/common_method";
export default {
  name: "CursorFollower",
  data() {
    return {
      bigger: false,
      biggertimeout: null,
      radius: 5, // 圆点半径
      isMobile: isMobile(),
    };
  },
  mounted() {
    document.addEventListener("mousemove", this.handleMouseMove);
  },
  methods: {
    handleMouseMove(e) {
      const x = e.clientX;
      const y = e.clientY;
      this.$refs?.pointer?.style.setProperty(
        "transform",
        `translate(${x}px, ${y}px)`
      );

      let vm = this;
      const navList = [
        ...document.getElementsByClassName("nav"),
        ...document.getElementsByClassName("cursor_bigger"),
      ];
      for (var i = 0; i < navList.length; i++) {
        navList[i].addEventListener("mouseover", function (e) {
          vm.bigger = true;
          vm.radius = 15;
        });
        navList[i].addEventListener("mouseout", function (e) {
          vm.bigger = false;
          vm.radius = 5;
        });
      }
    },
    // 变大n秒后缩小
    cursorFollowerBiggerSeconds(n) {
      if (this.biggertimeout) clearTimeout(this.biggertimeout);
      this.bigger = true;
      this.biggertimeout = setTimeout(() => {
        this.bigger = false;
      }, n * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer_container {
  width: 10px;
  height: 10px;
  top: -5px;
  left: -5px;
  background-color: white;
  border-radius: 50%;
  position: fixed;
  /*transition: all 0.3s ease-out;*/
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.12, 0.86, 0.23, 0.93);
  mix-blend-mode: difference;
  pointer-events: none;
  z-index: 500;
}

.on_nav {
  width: 50px;
  height: 50px;
  top: -25px;
  left: -25px;
}
</style>
